import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerGroupModel } from 'app/models/customer-group.model';
import { CustomerModel } from 'app/models/customer.model';
import { pencilIcon } from '@progress/kendo-svg-icons';
@Component({
  standalone: false,
  selector: 'customer-groups',
  templateUrl: './customer-groups.component.html',
  styleUrls: ['./customer-groups.component.scss']
})
export class CustomerGroupsComponent implements OnInit {
  pencilIcon=pencilIcon
  public groups_model: Array<CustomerGroupModel>;
  public customer_model: CustomerModel;
  public customer_id: string;
  public selected_customer_group_id: string;
  public customer_group_edit: boolean;
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.customer_group_edit = false;
    this.route.parent.data.subscribe(({ customer_model }) => {
      this.cleanup();
      this.customer_model = customer_model;
    });
    this.route.data.subscribe(({ groups_model }) => {
      this.cleanup();
      this.groups_model = groups_model;

    });
  }
  navigate(data: CustomerGroupModel) {
    this.selected_customer_group_id = data.id;
    this.customer_group_edit =true;
  }
  cleanup(){
    this.selected_customer_group_id = null;
    this.customer_group_edit =false;
  }

}
